module.exports = __webpack_public_path__ + "images/places/training_658-fc4c61f125f1dac9a194599c20eb2ef3.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/training_658.jpg
 ** module id = 321
 ** module chunks = 0
 **/